import { TargetGroup } from '@/helper/enums';

export function resolveCalculatorTargetGroup(
  pathname: string | null | undefined,
  targetGroupProp: TargetGroup | undefined
): TargetGroup {
  if (targetGroupProp !== undefined) {
    return targetGroupProp;
  }
  return pathname?.includes('gk/') ? TargetGroup.GK : TargetGroup.PK;
}
